import { createContext, useContext } from 'react';

/**
 * El contexto de "Muéstrame", en su propio archivo: el componente que ejecuta la
 * guía (`GuiaEnCurso.tsx`) solo exporta componentes, y cualquier pantalla puede
 * arrancar una guía con `useGuia()`.
 */
export interface ContextoGuia {
  /** Arranca la guía. `false` si no existe o este rol no la puede usar. */
  iniciar: (recetaId: string) => boolean;
  /** ¿Este rol puede usar esa guía? Para no ofrecer botones que no sirven. */
  puedeUsar: (recetaId: string) => boolean;
}

export const GuiaContext = createContext<ContextoGuia>({
  iniciar: () => false,
  puedeUsar: () => false,
});

export const useGuia = () => useContext(GuiaContext);
